import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 46 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--color-header-logo-primary)",
      d: "M10.743 24c8.174 0 11.51-5.72 11.51-12.465 0-5.41-3.035-11.502-11.11-11.502H0v.87h.124C.775.9 1.368.9 1.9 1.338c.568.467.634 1.12.634 6.622v8.113c0 5.378-.066 6.155-.634 6.622-.567.466-1.267.466-1.901.466V24zM7.374 1.055h2.736c4.47 0 7.14 4.663 7.14 11.19 0 6.87-2.97 10.788-6.94 10.788-.3 0-2.97-.032-2.97-.032z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--color-header-logo-primary)",
      d: "M45.08.837c-2.097 0-3.594.744-3.661 4-.033 1.457-.066 6.666-.066 6.666v12.464h-1.498L25.745 5.83c0 1.426.034 3.41.034 6.232 0 2.728 0 5.643.034 7.1.066 3.256 1.563 4 3.66 4v.806h-8.951v-.806c2.095 0 3.594-.744 3.66-4 .033-1.457.066-7.1.066-7.1l.034-8.154C22.784 1.89 22.352.96 20.455.837V.031h3.361c.865 0 4.126-.031 4.126-.031l11.88 15.069v-3.566c0-2.728 0-5.209-.034-6.666-.066-3.255-1.563-4-3.66-4V.031h8.951z"
    }, null, -1)
  ]))]))
}
export default { render: render }